import React from 'react'
import { Provider } from 'react-redux'
import createStore from './src/store/index'
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'

const wrapWithProvider = ({ element }) => {
  const store = createStore()
  dayjs.locale(ja)

  return <Provider store={store}>{element}</Provider>
}

export default wrapWithProvider
